import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Moment from 'moment'
import  VueScrollTo from 'vue-scrollto'
import browserDetect from "vue-browser-detect-plugin"
import VueGtag from "vue-gtag";
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import i18n from './i18n'

Vue.use(Loading, {
  canCancel: false,
  color: 'red',
  backgroundColor: 'black',
  loader: 'spinner',
  width: 100,
  height: 100,
  enforceFocus: false
})


// track Google Analytics
Vue.use(VueGtag, {
  config: { 
    id: "G-9W1F9VLG43",
    params: {
      send_page_view: true,
      appName: 'Inteli'
    }
  }
})

Vue.prototype.$moment = Moment

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueScrollTo)
Vue.use(browserDetect)

Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue(); // Global event bus

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
